import { useEffect, useState } from "react";
import AdminCompanyGroupDialogComponent from "./adminCompanyGroupDialog.component";
import adminApi from "../../../../../configs/apis/admins";

export default function AdminCompanyGroupDialogContainer({
  open,
  adminCompanyGroup,
  handleClose,
  handleSubmit,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [option, setOption] = useState([]);

  useEffect(async () => {
    setIsLoading(true);
    await adminApi.getCompanyGroupDropdown()
      .then((response) => {
        setOption(response.data);
        setIsLoading(false);
      });
  }, []);

  return (
    <AdminCompanyGroupDialogComponent
      open={open}
      value={adminCompanyGroup}
      option={option}
      handleSubmit={handleSubmit}
      handleClose={handleClose}
      isLoading={isLoading}
    />
  );
}
